// JS file for ProductList

const collapse = $('.j-collapse');

collapse.on('show.bs.collapse', (e) => {
  const $this = $(e.currentTarget);
  const icon = $($this.prev('.c-sidebar__link').find('i')[0]);

  icon.removeClass('fa-caret-right');
  icon.addClass('fa-caret-down');
});

collapse.on('hide.bs.collapse', (e) => {
  const $this = $(e.currentTarget);
  const icon = $($this.prev('.c-sidebar__link').find('i')[0]);

  icon.removeClass('fa-caret-down');
  icon.addClass('fa-caret-right');
});
